export default "__VITE_ASSET__BjbJEYFo__"